// export const SEARCH_BASE_URL = 'https://news.foundationcenter.org/api/search';
// export const AUTH_BASE_URL = 'https://news.foundationcenter.org/api/auth';

export const BASE = `https://${window.location.hostname}`;
export const SEARCH_BASE_URL = `${BASE}/api/search`;
export const AUTH_BASE_URL = `${BASE}/api/auth`;

export const HEADERS = {
    "Accept": "application/json, text/plain, */*",
    "Content-Type": "application/json"
}


// WEBPACK FOOTER //
// ./src/config.js